const VERIFIER_LENGTH = 128;
const UNRESERVED_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';

export async function computeChallenge(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return base64UrlEncode(new Uint8Array(digest));
}

export async function createPkcePair(): Promise<{ verifier: string; challenge: string }> {
  const verifier = randomVerifier();
  const challenge = await computeChallenge(verifier);
  return { verifier, challenge };
}

function randomVerifier(): string {
  const bytes = new Uint8Array(VERIFIER_LENGTH);
  crypto.getRandomValues(bytes);
  let result = '';
  for (const byte of bytes) {
    result += UNRESERVED_CHARS[byte % UNRESERVED_CHARS.length];
  }
  return result;
}

function base64UrlEncode(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
